module.exports = __webpack_public_path__ + "img/OasisLogo2.fc904f6a.png";